import { UploadDocumentForServiceAgreementLanguageEnum } from 'pco-product-service-internal-consumer';
import { serviceAgreementApi } from 'api';

export const sendDocumentToApi = async (
  serviceAgreementId: string,
  document: Blob,
  languange: string,
  formCode: string,
) => {
  const response = await serviceAgreementApi.uploadDocumentForServiceAgreementRaw({
    serviceAgreementId,
    file: document as File,
    language: languange as UploadDocumentForServiceAgreementLanguageEnum,
    formCode,
  });

  return { status: response.raw.status };
};
